import {ChangeDetectionStrategy, Component, computed, input, InputSignal, OnInit} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
  MatTable, MatTableDataSource
} from '@angular/material/table';
import {MatTooltip} from '@angular/material/tooltip';

import {EventRankingModel} from 'shared/models';
import {ConfigService} from '../../config.service';

@Component({
  selector: 'event-ranking-ui',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, MatTable, MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTooltip],
  templateUrl: './event-ranking-ui.html',
  styleUrl: './event-ranking-ui.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventRankingUi implements OnInit {
  eventsRankings: InputSignal<EventRankingModel[]> = input.required<EventRankingModel[]>();

  protected header1Columns: string[] = ['rank', 'player', 'points', 'matches', 'sets', 'games'];
  protected header2Columns: string[] = ['matchesPlayed', 'matchesFor', 'matchesAgainst', 'matchesDiff', 'setsFor', 'setsAgainst', 'setsDiff', 'gamesFor', 'gamesAgainst', 'gamesDiff'];
  protected displayedColumns: string[] = ['rank', 'player', 'points', 'matchesPlayed', 'matchesFor', 'matchesAgainst', 'matchesDiff', 'setsFor', 'setsAgainst', 'setsDiff', 'gamesFor', 'gamesAgainst', 'gamesDiff'];

  protected dataSource = computed((): MatTableDataSource<EventRankingModel> => {
    return new MatTableDataSource<EventRankingModel>(this.eventsRankings());
  });

  protected bucketUrl!: string;

  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    this.bucketUrl = this.configService.config.bucketUrl;
  }
}
